'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { getAuthUrlState } from './check-and-open-url-rules';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';

interface AuthUrlInitializerProps {
  onOpen: () => void;
}

export const AuthUrlInitializer = ({ onOpen }: AuthUrlInitializerProps) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();
  const { should } = getAuthUrlState({ pathname, search, isPh: brandIsPh });

  useEffect(() => {
    if (should) {
      onOpen();
    }
  }, [onOpen, should]);

  return null;
};
